const VoiceAgentMenuTypes = (that = {}) => {
    return [
        {
            enabled: true,
            key: "agents",
            label: that.$t ? that.$t(`Agents`) : "Agents",
            icon: {
                type: "material-icons",
                name: "support_agent",
            },
        },
        {
            enabled: true,
            key: "knowledge-base",
            label: that.$t ? that.$t(`Knowledge Base`) : "Bilgi Tabanı",
            icon: {
                type: "material-icons",
                name: "psychology",
            },
        },
        {
            enabled: true,
            key: "phone-numbers",
            label: that.$t ? that.$t(`Phone Numbers`) : "Telefon Numaraları",
            icon: {
                type: "material-icons",
                name: "phone",
            },
        },
        {
            enabled: true,
            key: "batch-call",
            label: that.$t ? that.$t(`Batch Call`) : "Batch Call",
            icon: {
                type: "material-icons",
                name: "call",
            },
        },
        {
            enabled: true,
            key: "call-history",
            label: that.$t ? that.$t(`Call History`) : "Call History",
            icon: {
                type: "material-icons",
                name: "history",
            },
        },
        {
            enabled: true,
            key: "automations",
            label: that.$t ? that.$t("automation.automations") : "Automations",
            icon: {
                type: "component",
                name: "AutomationIcon",
                class: "myIcon",
                style: { fill: "var(--color-icon-primary-default)" },
            },
        },
    ];
};

export default VoiceAgentMenuTypes;
